import { put, call } from "redux-saga/effects";

import { BFFAgent } from 'BFFAgent'
import {
    GESTION_OPERATIVA_RE_ENTERED_VEHICLE_FAILURE,
    GESTION_OPERATIVA_RE_ENTERED_VEHICLE_SUCCESS
} from '../constants'

export function* reEnteredVehicleSaga(id) {
    try {
        const res = yield call(BFFAgent.Sales.reEnteredVehicle, id)
        yield put({
            type: GESTION_OPERATIVA_RE_ENTERED_VEHICLE_SUCCESS,
            data: res
        })
    } catch (err) {
        yield put({
            type: GESTION_OPERATIVA_RE_ENTERED_VEHICLE_FAILURE,
            data: { error: err }
        })
    }
}
